import { useState } from 'react';
import useClient from 'api/client';
import { DatasetCreateFormData } from 'types/Forms';
import createDataset from 'api/Dataset/createDataset';
import importDataset from 'api/Dataset/importDataset';
export default function useNewDataset(
    setCreationError: React.Dispatch<React.SetStateAction<string>>,
) {
    const client = useClient() as unknown as {
        mutate: (query: any) => Promise<any>;
    };
    const [creationLoading, setLoading] = useState(false);
    const createNewDataset = async (formData: DatasetCreateFormData) => {
        setLoading(true);
        try {
            const response = await client?.mutate(createDataset(formData));
            if (!response.errors) {
                setCreationError('');
                return response.data.createDataset;
            } else {
                setCreationError(response.errors[0].message);
            }
        } finally {
            setLoading(false);
        }
    };
    const importNewDataset = async (formData: DatasetCreateFormData) => {
        setLoading(true);
        try {
            const response = await client?.mutate(importDataset(formData));
            if (!response.errors) {
                setCreationError('');
                return response.data.importDataset;
            } else {
                setCreationError(response.errors[0].message);
            }
        } finally {
            setLoading(false);
        }
    };

    return { creationLoading, createNewDataset, importNewDataset };
}
